import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const downloadVideoFile = createAsyncThunk("downloadVideoFile", async (post_id) => {
    const response = await axiosInstance.get(`/post/dowload/${post_id}/`, {
        responseType: 'blob'
    });
    try {
        return {
            blob: response.data,
            filename: response.headers['content-disposition']
                ? response.headers['content-disposition'].split('filename=')[1]?.replace(/"/g, '')
                : `video_${post_id}.mp4`
        };
    } catch (error) {
        throw error;
    }
});

export const DownloadVideo = createSlice({
    name: "Download",
    initialState: {
        loading: false,
        error: null,
        data: {},
        downloadFile: null,
    },
    extraReducers: (builder) => {

        builder.addCase(downloadVideoFile.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(downloadVideoFile.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadFile = action.payload;
        });
        builder.addCase(downloadVideoFile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default DownloadVideo.reducer;
